import { z } from "zod";
import { networkSchema } from "./common.js";
export const networkStatsResponseSchema = z.object({
    network: networkSchema,
    // count(*) comes back as a string from postgres.js (bigint safety); other
    // drivers hand back numbers — normalize to string either way.
    blockCount: z.coerce.string(),
    txCount: z.coerce.string(),
    proposedBlock: z.number(),
    checkpointedBlock: z.number(),
    provenBlock: z.number(),
    finalizedBlock: z.number(),
});
//# sourceMappingURL=networks.js.map